import React, { useEffect, useState } from 'react';
import App from '../../../app';
import { RatingForm } from '../../../components/form/rating-form';
import { GetUser } from '../../../services/Session';
import { GetOrderById } from '../../../services/Transaction';

export function ratingForm(props) {
	const user = GetUser()
	const [items, setItems] = useState([])

	const getOrder = async () => {
		try {
			const { data } = await GetOrderById(props.match.params.id)
			if (data.line_items && data.line_items.length > 0) {
				setItems(data.line_items);
			}
		} catch (err) {
			handleError(err, getCatalog, retryCountRef, false, undefined);
		}
	};

	useEffect(() => {
		const getData = async () => {
			await getOrder();
		};

		getData();
	}, []);

	return (
		<App user={user}>
			<div className='p-4'>
			{items.map((item, i) => {
				return <RatingForm id={item?.product?.id} title={item?.product?.name} image_url={item?.product?.image?.url} />
			})}
			</div>
		</App>
	)
}
